export enum ProcessTabOption {
  PUBLISHED = 'PUBLISHED',
  DRAFTS = 'DRAFTS',
  SHARED = 'SHARED'
}

export enum ProcessViewMode {
  EXPANDED_VIEW = 'expanded-view',
  LIST_VIEW = 'list-view'
}

export enum BlockTextContentType {
  TEXT_BLOCK = 'TextBlock'
}

export enum ProcessList {
  LIMIT = 40
}

export enum EShareProcessDetailOption {
  GROUP = 'group',
  USER = 'user'
}
